<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let _ of valuesFormArray.controls; let idx = index; trackBy: trackByFunc">
		<button *ngIf="!isDefaultFilter" type="button" mat-icon-button class="circle-icon-remove" (click)="removeValue(idx)"><mat-icon color="accent" svgIcon="md:remove"></mat-icon></button>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-box" subscriptSizing="dynamic">
			<mat-label>{{filter.placeholderFrom}}</mat-label>
			<input
					matInput
					spellcheck="false"
					autocomplete="off"
					[copoDatepicker]="startDatepicker"
					[copoFormat]="formatType"
					(typeChange)="onTypeChange($event)"
					(click)="startDatepicker.open()"
					#startDateInput
					[max]="toControl(idx).value"
					[formControl]="fromControl(idx)"
					[attr.aria-label]="filter.label + ' ' + filter.placeholderFrom">
			<button type="button" mat-icon-button [class.visibility-hidden]="!fromControl(idx).value" matSuffix class="clear-date" (click)="clearFrom(idx)" tabindex="-1">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-datepicker-toggle matSuffix class="filter-icon multiple-sufix" [for]="startDatepicker"></mat-datepicker-toggle>
			<mat-datepicker #startDatepicker [startAt]="fromControl(idx).value || null"></mat-datepicker>
		</mat-form-field>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-box" subscriptSizing="dynamic">
			<mat-label>{{filter.placeholderTo}}</mat-label>
			<input
					matInput
					spellcheck="false"
					autocomplete="off"
					[copoDatepicker]="endDatepicker"
					[copoFormat]="formatType"
					(typeChange)="onTypeChange($event)"
					(click)="endDatepicker.open()"
					#endDateInput
					[formControl]="toControl(idx)"
					[min]="fromControl(idx).value"
					[attr.aria-label]="filter.label + ' ' + filter.placeholderTo">
			<button type="button" mat-icon-button [class.visibility-hidden]="!toControl(idx).value" matSuffix class="clear-date" (click)="clearTo(idx)" tabindex="-1">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-datepicker-toggle [for]="endDatepicker" class="multiple-sufix" matSuffix></mat-datepicker-toggle>
			<mat-datepicker #endDatepicker [startAt]="toControl(idx).value || null"></mat-datepicker>
		</mat-form-field>
	</div>
</ng-container>
